import _ from 'lodash';
import { FC, useCallback, useEffect, useState } from 'react';
import { PlayerMeta, Team } from '../../../types';
import { CbParticipantPickerLayout } from './CbParticipantPickerLayout';
import { CbParticipantSearchHeader } from './CbParticipantSearchHeader';
export interface CbParticipantPickerContainerProps {
  typeOfSearch: string;
  players: PlayerMeta[];
  teams: Team[];
  selectedParticipants: any[];
  saveselectedParticipants: (player: PlayerMeta[], teams: Team[], current: string) => void;
  setTextFilter: (query: string) => void;
  setTeamIds: (filter: number[] | null) => void;
  handleSort: (list: any[]) => PlayerMeta[];
  handlePrimarySelected?: (id: number, notificationsEnabled: boolean, participantId?: string | number) => void;
  showNotificationSettings?: boolean;
  teamId?: number;
  hideTabs?: boolean;
  maxHeight?: string;
}
export const CbParticipantPickerContainer: FC<CbParticipantPickerContainerProps> = ({
  typeOfSearch,
  players,
  teams,
  selectedParticipants,
  teamId,
  saveselectedParticipants,
  setTextFilter,
  handleSort,
  handlePrimarySelected,
  setTeamIds,
  showNotificationSettings,
  hideTabs = false,
  maxHeight
}) => {
  const [playerList, setPlayerList] = useState(players);
  const [availablePlayers, setAvailablePlayers] = useState<PlayerMeta[]>([]);
  useEffect(() => {
    setPlayerList([]);
  }, [typeOfSearch]);
  useEffect(() => {
    // If we're mid-search and the results haven't returned yet, hold your horses
    if (!players) return;
    const selectedIds = selectedParticipants.map(player => parseInt(player.id));
    const filteredPlayers = players.filter(player => !selectedIds.includes(parseInt(player.id as string)));
    setAvailablePlayers(filteredPlayers);
    setPlayerList(filteredPlayers);
  }, [players, selectedParticipants]);
  const onPlayerSearchFilter = useCallback(_.debounce(async (searchQuery: string): Promise<void> => {
    let query = searchQuery;
    if (searchQuery.includes('"')) {
      query = searchQuery.replaceAll('"', '');
    }
    setTextFilter(query);
  }, 250), []);
  const handleTeamFilter = (filter: string | null): void => {
    if (filter === 'Clear') {
      setTeamIds(null);
    } else {
      const teamFilterId = teams.filter(team => team.name === filter);
      setTeamIds([teamFilterId[0].id]);
    }
  };

  // indiviual participant functions
  const handleAddParticipant = (player: PlayerMeta): void => {
    setPlayerList(playerList.filter(unsavedPlayer => unsavedPlayer?.id !== player?.id));
    saveselectedParticipants(handleSort([...selectedParticipants, player]), [], typeOfSearch);
  };
  const handleRemoveParticipant = (index: number, id: number): void => {
    const removeSelected = [...selectedParticipants];
    removeSelected.splice(index, 1);
    saveselectedParticipants(removeSelected, [], typeOfSearch);
    setPlayerList(playerList.filter(unsavedPlayer => unsavedPlayer?.id !== id));
  };
  const handleAddAllParticipants = (): void => {
    setPlayerList([...selectedParticipants, ...availablePlayers]);
    saveselectedParticipants(handleSort([...selectedParticipants, ...availablePlayers]), [], 'individual');
  };
  const handleClearAllParticipants = (): void => {
    setPlayerList([]);
    saveselectedParticipants([], [], 'individual');
  };
  return <>
        <CbParticipantSearchHeader onPlayerSearchChange={onPlayerSearchFilter} handleTeamFilter={handleTeamFilter} teams={teams} hideTabs={hideTabs} data-sentry-element="CbParticipantSearchHeader" data-sentry-source-file="CbParticipantPickerContainer.tsx" />
        <CbParticipantPickerLayout showNotificationSettings={showNotificationSettings} availablePlayers={availablePlayers} selectedParticipants={selectedParticipants} teamId={teamId} handleAddParticipant={handleAddParticipant} handleRemoveParticipant={handleRemoveParticipant} handleAddAllParticipants={handleAddAllParticipants} handleClearAllParticipants={handleClearAllParticipants} handlePrimarySelected={handlePrimarySelected} maxHeight={maxHeight} data-sentry-element="CbParticipantPickerLayout" data-sentry-source-file="CbParticipantPickerContainer.tsx" />
      </>;
};